import { useAuth0 } from '@auth0/auth0-react';
import { useMemo } from 'react';

import { QuestionnairePanelLoader } from './QuestionnairePanelLoader.tsx';
import type { QuestionnairePanelProps } from './types.ts';

import { useEnvironmentConfig } from '#src/hooks/environment.tsx';

type Props = Pick<
  QuestionnairePanelProps['positionProfile'],
  | 'jobCategories'
  | 'positionLocation'
  | 'positionOrganizations'
  | 'positionTitle'
> & {
  questionnaireId: QuestionnairePanelProps['questionnaireId'];
};

export const QuestionnairePanel = ({
  positionLocation,
  positionOrganizations,
  positionTitle,
  jobCategories,
  questionnaireId,
}: Props) => {
  const { getAccessTokenSilently } = useAuth0();
  const { seekAnzSchemeId } = useEnvironmentConfig();
  const options = useMemo<QuestionnairePanelProps>(
    () => ({
      getAuthToken: () =>
        getAccessTokenSilently().then((token) => {
          if (!token) {
            throw new Error('Failed to get access token');
          }
          return token;
        }),
      positionProfile: {
        positionOrganizations,
        positionTitle,
        positionLocation,
        jobCategories,
      },
      questionnaireId,
      schemeId: seekAnzSchemeId,
      mode: 'Create',
    }),
    [
      positionOrganizations,
      positionTitle,
      positionLocation,
      jobCategories,
      questionnaireId,
      seekAnzSchemeId,
      getAccessTokenSilently,
    ],
  );

  return <QuestionnairePanelLoader props={options} />;
};
